import { getBootstrapColorName } from "../../../../utils";

const applyMarketFilters = (marketFilters, data, opContainer) => {
  return new Promise((resolve, reject) => {
    let items = [];
    let filteredData = [];

    // Apply accepted_certificates filter
    if (marketFilters.accepted_certs.length > 0) {
      for (let i of data) {
        let certificates = i.certificates;
        let acceptedCertificates = marketFilters.accepted_certs;
        let accepted = false;
        for (let j of certificates) {
          if (acceptedCertificates.includes(j)) {
            accepted = true;
          } else {
            accepted = false;
            break;
          }
        }
        if (accepted) {
          filteredData.push(i);
        }
      }
    } else {
      filteredData = data;
    }

    // Apply accepted_vatieties filter
    if (marketFilters.accepted_varieties.length > 0) {
      let filteredData2 = [];
      for (let i of filteredData) {
        let variety = i.variety_name;
        let acceptedVarieties = marketFilters.accepted_varieties;
        if (acceptedVarieties.includes(variety)) {
          filteredData2.push(i);
        }
      }
      filteredData = filteredData2;
    }

    // Apply accepted classifications filter
    if (marketFilters.accepted_classifications.length > 0) {
      let filteredData2 = [];
      for (let i of filteredData) {
        if (i.inspections.length > 0) {
          let classification = i.inspections[0].name;
          let acceptedClassifications = marketFilters.accepted_classifications;
          if (acceptedClassifications.includes(classification)) {
            filteredData2.push(i);
          }
        }
      }
      filteredData = filteredData2;
    }

    for (let i = 0; i < filteredData.length; i++) {
      const inspection = filteredData[i].inspections.length > 0 ? filteredData[i].inspections[0] : null;
      const inspectionColor = inspection ? inspection.color : "#ddd";
      const inspectionScore = inspection ? inspection.score : 100;
      const potentialPercentage = (100 - inspectionScore) / 100;
      const potential_kg = filteredData[i].net_kilograms * potentialPercentage;
      const potential_kg_after_dh = (potential_kg * (100 - opContainer.dh)) / 100;
      const potential_boxes = Math.floor(potential_kg_after_dh / parseFloat(opContainer.net_weight));
      const item = {
        index: i,
        id: filteredData[i].id,
        creation_date: filteredData[i].creation_date,
        pallet_number: filteredData[i].pallet_number,
        variety_name: filteredData[i].variety_name,
        condition: filteredData[i].condition,
        lot_number: filteredData[i].lot_number,
        origin_name: filteredData[i].origin_name,
        net_kilograms: filteredData[i].net_kilograms,
        daystay: filteredData[i].daystay,
        inspection,
        color: getBootstrapColorName(inspectionColor),
        potential_kg: potential_kg.toFixed(2),
        potential_percentage: (potentialPercentage * 100).toFixed(2),
        potential_kg_after_dh: potential_kg_after_dh.toFixed(2),
        potential_boxes: potential_boxes,
        selected: false,
        rest: opContainer.net_weight
      };
      items.push(item);
    }
    //Sort items by desc daystay
    items.sort((a, b) => {
      return b.daystay - a.daystay;
    });
    resolve(items);
  });
};

export default applyMarketFilters;
